import { getFormInitialValues } from 'utils/methods/helpers';
import API from 'services/api';
import isEmpty from 'lodash/isEmpty';
import {
  validateEmail,
  validateName,
  validatePositiveInteger,
  validateRequired,
  validateRequiredPhoneNumber,
  validationObject,
} from 'utils/validations';

export const initialValues = data => {
  return getFormInitialValues(data);
};
export const pendingCompanyValidationSchema = editMode => {
  if (!editMode) {
    return validationObject({
      name: validateName(50, true),
      address: validateName(250, true),
      country: validateRequired(),
      operationsPhoneNumber: validateRequiredPhoneNumber(),
      firstName: validateName(30, true),
      lastName: validateName(30, true),
      email: validateEmail(true),
      phoneNumber: validateRequiredPhoneNumber(),
    });
  } else {
    return validationObject({
      trialLength: validatePositiveInteger(false),
      trialAutoExtendLength: validatePositiveInteger(false),
      region: validateRequired(),
    });
  }
};
export const generalSection = () => [
  {
    field: 'name',
    label: 'Company Name',
    type: 'text',
    required: false,
    disabled: true,
    size: 'full',
  },
  {
    field: 'address',
    type: 'text',
    required: true,
    disabled: true,
    size: 'full',
  },
  {
    field: 'trialLength',
    type: 'text',
    fieldType: 'number',
    required: false,
    size: 'half',
    placeholder: 'Defaults to 14 days',
  },
  {
    field: 'trialAutoExtendLength',
    type: 'text',
    fieldType: 'number',
    required: false,
    size: 'half',
    placeholder: 'Defaults to 14 days',
  },
  {
    label: 'Region',
    field: 'region',
    type: 'async-select',
    fetchOptions: API.fetchRegionList,
    dataTransform: ({ data }) => {
      return data.map(m => ({ id: m.id, name: m.name }));
    },
    fetchFilters: {
      archived: false,
    },
    multiple: false,
    optionLabelKey: 'name',
    required: true,
  },
];
export const createGeneralSection = countries => {
  return [
    {
      field: 'name',
      label: 'Company Name',
      type: 'text',
      required: true,
      size: 'full',
    },
    {
      field: 'address',
      type: 'text',
      required: true,
      size: 'full',
    },
    {
      field: 'country',
      label: 'Country',
      type: 'select',
      options: countries.map(c => ({
        ...c,
        id: c.id,
        name: c.countryName,
      })),
      required: true,
      size: 'full',
    },
    {
      field: 'operationsPhoneNumber',
      label: 'Operational Phone Number',
      secondaryKey: 'operationsCountry',
      type: 'phone',
      required: true,
      size: 'half',
      secondaryOptions: countries,
    },
    {
      field: 'firstName',
      type: 'text',
      required: true,
      size: 'full',
    },
    {
      field: 'lastName',
      type: 'text',
      required: true,
      size: 'full',
    },
    {
      field: 'email',
      type: 'text',
      required: true,
      size: 'half',
      placeholder: 'Enter email',
    },
    {
      field: 'phoneNumber',
      label: 'Manager Phone Number',
      secondaryKey: 'phoneCountry',
      type: 'phone',
      required: true,
      size: 'half',
      secondaryOptions: countries,
    },
  ];
};

export const detailSection = subscriptions => {
  //loop through all 'User' subscriptions and add them to a radio group
  if (isEmpty(subscriptions)) {
    return [];
  }
  const userSub = subscriptions.filter(item => {
    return item.name.startsWith('User');
  });
  const featuresSub = subscriptions.filter(item => {
    return item.name.startsWith('Feature');
  });
  const langSub = subscriptions.filter(item => {
    return item.name.startsWith('Language');
  });
  const servicesSub = subscriptions.filter(item => {
    return item.name.startsWith('Service');
  });
  const siteSub = subscriptions.filter(item => {
    return item.name.startsWith('Site');
  });
  const otherSub = subscriptions.filter(item => {
    return item.platform === 'OTHER';
  });
  return [
    getRadioSubscriptionField('users', 'users', userSub),
    getCheckBoxSubscriptionField('services', 'services', servicesSub),
    getRadioSubscriptionField('sites', 'sites', siteSub),
    getCheckBoxSubscriptionField('features', 'features', featuresSub),
    getCheckBoxSubscriptionField('languages', 'languages', langSub),
    getCheckBoxSubscriptionField('others', 'others', otherSub),
  ];
};
const getRadioSubscriptionField = (label, field, subscriptions) => {
  const options = subscriptions.map(s => {
    return {
      ...s,
      name: label,
      id: s.name,
      value: s.name,
    };
  });
  return {
    label: label,
    options: options,
    type: 'radio-buttons',
    field: field,
    valueType: 'object', // returns the whole object when option is selected, otherwise gives the selected string
  };
};
const getCheckBoxSubscriptionField = (label, field, subscriptions) => {
  const options = subscriptions.map(s => {
    return {
      ...s,
      id: s.name,
      name: s.name,
      icon: s.icon,
    };
  });
  return {
    label: label,
    options: options,
    type: 'checkbox-options',
    field: field,
    denseFormGroup: false,
  };
};
